import { JoinOrganizationRequest } from '@melio/platform-api-axios-client';
import { isDateExpired } from '@melio/platform-utils/src/date-utils/utils';

export const isJoinOrganizationRequestExpired = (joinOrganizationRequest: JoinOrganizationRequest): boolean =>
  !!joinOrganizationRequest.expired && isDateExpired(joinOrganizationRequest.expired);
